<template>
  <div>
    <Head />

    <div class="breadcrumb_box" aria-label="breadcrumb" v-if="EventItemDetailData">
      <ol class="breadcrumb container">
        <li class="breadcrumb-item"><router-link to="/">首頁</router-link></li>
        <li class="breadcrumb-item" v-if="EventItemDetailData.Event">{{ EventItemDetailData.Event.Name }}</li>
        <li class="breadcrumb-item active" v-if="EventItemDetailData.EventItem" aria-current="page">{{
          EventItemDetailData.EventItem.Name }}</li>
      </ol>
    </div>
    <div class="wrapper member_information member_information_1_main member_information_1_main_2"
      v-if="EventItemDetailData.EventItemDetail">
      <section class="main">
        <div class="container">
          <div class="step_box">
            <div class="" @click="goto('BaseInfo')" style="cursor: pointer;">基本資料</div>
            <div class="step">品項管理</div>
            <div class="" @click="goto('ReqDoc')" style="cursor: pointer;">應備文件</div>
            <div v-if="EventItemDetailData.Review.ReviewStatus == 0" class="" @click="sendReview()"
              style="cursor: pointer;">送出審核</div>
            <div v-if="EventItemDetailData.Review.ReviewStatus == 3" class="" @click="sendReview()"
              style="cursor: pointer;">重新送出審核</div>
            <div v-if="EventItemDetailData.Review.ReviewStatus == 1" class="">審核通過</div>
            <div v-if="EventItemDetailData.Review.ReviewStatus == 2" class="">審核失敗</div>
            <div v-if="EventItemDetailData.Review.ReviewStatus == 99" class="">審核中</div>
            <div v-if="EventItemDetailData.Review.ReviewStatus == 999" class="">重審中</div>
          </div>
          <div id="stet_1" class="box show">
            <h1>
              基本資料
              <div class="btn_home">
                <router-link :to="{ name: 'EventItem', params: { EId: EventItemDetailData.Event.EId } }"
                  tag="button">返回列表</router-link>
              </div>
            </h1>
            <div class="bg">
              <div class="form-group project full" v-if="false">
                <label for=""><span>[必填]</span>料理類型</label>
                <div class="check_group radio radio_1">
                  <div class="form-check form-check-inline" style="flex-basis: 25%;">
                    <input class="form-check-input" type="radio" id="T5_CuisineType_1" v-bind:value="1"
                      v-model="EventItemDetailData.EventItemDetail.T5_CuisineType" data-field="T5_CuisineType">
                    <label class="form-check-label" for="T5_CuisineType_1">
                      傳統麻油料理
                    </label>
                  </div>
                  <div class="form-check form-check-inline" style="flex-basis: 25%;">
                    <input class="form-check-input" type="radio" id="T5_CuisineType_2" v-bind:value="2"
                      v-model="EventItemDetailData.EventItemDetail.T5_CuisineType" data-field="T5_CuisineType">
                    <label class="form-check-label" for="T5_CuisineType_2">
                      創新麻油料理
                    </label>
                  </div>
                </div>
              </div>
              <div class="form-group project full">
                <label for=""><span>[必填]</span>組別</label>
                <div class="check_group radio radio_1">
                  <div class="form-check form-check-inline" style="flex-basis: 25%;">
                    <input class="form-check-input" type="radio" id="T5_RegistrationCategory_1" v-bind:value="1"
                      v-model="EventItemDetailData.EventItemDetail.T5_RegistrationCategory" data-field="T5_RegistrationCategory">
                    <label class="form-check-label" for="T5_RegistrationCategory_1">
                      傳統組
                    </label>
                  </div>
                  <div class="form-check form-check-inline" style="flex-basis: 25%;">
                    <input class="form-check-input" type="radio" id="T5_RegistrationCategory_2" v-bind:value="2"
                      v-model="EventItemDetailData.EventItemDetail.T5_RegistrationCategory" data-field="T5_RegistrationCategory">
                    <label class="form-check-label" for="T5_RegistrationCategory_2">
                      創新組
                    </label>
                  </div>
                </div>
              </div>
              <div class="form-group full">
                <label for=""><span>[必填]</span>菜名</label>
                <input type="text" class="form-control" v-model="EventItemDetailData.EventItemDetail.T5_DishName"
                  data-field="T5_DishName" data-required="1" data-required-msg="請填寫菜名" aria-describedby=""
                  placeholder="請填寫菜名">
              </div>
            </div>
            <h1>製作方法說明</h1>
            <div class="form-group full content">
              <h2 class=""><span>[必填]</span>主食材</h2>
              <div class="form-group full">
                <label for="">內容</label>
                <textarea rows="5" v-model="EventItemDetailData.EventItemDetail.T5_MainIngredientContent"
                  data-field="T5_MainIngredientContent" aria-describedby="" data-required="1"
                  data-required-msg="請填寫主食材內容" placeholder="請填寫主食材內容"></textarea>
              </div>
              <div class="form-group full">
                <label for="">品牌/產地來源</label>
                <textarea rows="5" v-model="EventItemDetailData.EventItemDetail.T5_MainIngredientBrandOrOrigin"
                  data-field="T5_MainIngredientBrandOrOrigin" aria-describedby="" data-required="1"
                  data-required-msg="請填寫主食材品牌/產地來源" placeholder="請填寫主食材品牌/產地來源"></textarea>
              </div>
            </div>
            <hr>
            <div class="form-group full content">
              <h2 class=""><span>[必填]</span>副材料</h2>
              <div class="form-group full">
                <label for="">內容</label>
                <textarea rows="5" v-model="EventItemDetailData.EventItemDetail.T5_SecondaryIngredientContent"
                  data-field="T5_SecondaryIngredientContent" aria-describedby="" data-required="1"
                  data-required-msg="請填寫副材料內容" placeholder="請填寫副材料內容"></textarea>
              </div>
              <div class="form-group full">
                <label for="">品牌/產地來源</label>
                <textarea rows="5" v-model="EventItemDetailData.EventItemDetail.T5_SecondaryIngredientBrandOrOrigin"
                  data-field="T5_SecondaryIngredientBrandOrOrigin" aria-describedby="" data-required="1"
                  data-required-msg="請填寫副材料品牌/產地來源" placeholder="請填寫副材料品牌/產地來源"></textarea>
              </div>
            </div>
            <hr>
            <div class="form-group full content">
              <h2 class=""><span>[必填]</span>調味料</h2>
              <div class="form-group full">
                <label for="">內容</label>
                <textarea rows="5" v-model="EventItemDetailData.EventItemDetail.T5_SeasoningContent"
                  data-field="T5_SeasoningContent" aria-describedby="" data-required="1" data-required-msg="請填寫調味料內容"
                  placeholder="請填寫調味料內容"></textarea>
              </div>
              <div class="form-group full">
                <label for="">品牌/產地來源</label>
                <textarea rows="5" v-model="EventItemDetailData.EventItemDetail.T5_SeasoningBrandOrOrigin"
                  data-field="T5_SeasoningBrandOrOrigin" aria-describedby="" data-required="1"
                  data-required-msg="請填寫調味料品牌/產地來源" placeholder="請填寫調味料品牌/產地來源"></textarea>
              </div>
            </div>
            <hr>
            <div class="form-group full content">
              <h2 class=""><span>[必填]</span>料理內容介紹及製作手法說明</h2>
              <div class="form-group full">
                <textarea rows="5" v-model="EventItemDetailData.EventItemDetail.T5_CookingMethodDescription"
                  data-field="T5_CookingMethodDescription" aria-describedby="" data-required="1"
                  data-required-msg="請填寫料理內容介紹及製作手法說明" placeholder="請填寫料理內容介紹及製作手法說明"></textarea>
              </div>
              <p>
                請簡述本道菜餚如何呈現製作手法及使用之臺灣油蔥品牌，例如：擺盤、料理手法、刀工技法、食材處理等，150字內
              </p>
            </div>
            <h1>菜餚照片</h1>
            <div class="bg">
              <div class="form-group file_box full">
                <label for=""><span>[必填]</span>照片-1<span style="font-size: 1.3rem;"
                    v-if="EventItemDetailData.EventItemDetail.EIDId != -1 && EventItemDetailData.EventItemDetail.T5_DishPhoto">
                    (已上傳, 可更新)</span></label>
                <div class="file">
                  <input type="file" id="T5_DishPhoto"
                    accept=".bmp,.jpg,.jpeg,.gif,.png"
                    @change="checkFiles">
                  <input type="hidden" id="T5_DishPhoto_name" data-namgtag="1" />
                  <input type="hidden" v-model="EventItemDetailData.EventItemDetail.T5_DishPhoto"
                    data-field="T5_DishPhoto" id="T5_DishPhoto_data" data-required="1" data-required-msg="請上傳照片-1" />
                  <button>上傳</button>
                </div>
                <p>
                  可上傳的文件格式包括：JPG或GIF或PNG檔<br>建議每個檔案大小不超過100MB，且圖片檔案建議具備300dpi解析度及至少1000px的寬度。
                </p>
              </div>
              <div class="form-group file_box full">
                <label for="">照片-2<span style="font-size: 1.3rem;"
                    v-if="EventItemDetailData.EventItemDetail.EIDId != -1 && EventItemDetailData.EventItemDetail.T5_DishPhoto2">
                    (已上傳, 可更新)</span></label>
                <div class="file">
                  <input type="file" id="T5_DishPhoto2"
                    accept=".bmp,.jpg,.jpeg,.gif,.png"
                    @change="checkFiles">
                  <input type="hidden" id="T5_DishPhoto2_name" data-namgtag="1" />
                  <input type="hidden" v-model="EventItemDetailData.EventItemDetail.T5_DishPhoto2"
                    data-field="T5_DishPhoto2" id="T5_DishPhoto2_data" />
                  <button>上傳</button>
                </div>
                <p>
                  可上傳的文件格式包括：JPG或GIF或PNG檔<br>建議每個檔案大小不超過100MB，且圖片檔案建議具備300dpi解析度及至少1000px的寬度。
                </p>
              </div>
            </div>
            <hr>
            <div class="btn_box">
              <router-link :to="{ name: 'EventItem', params: { EId: EventItemDetailData.Event.EId } }"
                tag="button">返回列表</router-link>
              <!-- <button @click="save(true)"
                v-if="EventItemDetailData.Review.ReviewStatus == 0 || EventItemDetailData.Review.ReviewStatus == 3">暫存資料</button> -->
              <button @click="save(false)"
                v-if="EventItemDetailData.Review.ReviewStatus == 0 || EventItemDetailData.Review.ReviewStatus == 3">儲存資料</button>
            </div>
          </div>
        </div>
      </section>
    </div><!-- wrapper -->
    <Footer />
  </div>
</template>
<script>
import Head from "@/components/Head.vue";
import Footer from "@/components/Footer.vue";

import Vue from "vue";

import axios from "axios";
import VueAxios from "vue-axios";
Vue.use(VueAxios, axios);


import AES from "@/utils/aes.js";
import Validate from "@/utils/validate.js";

export default {
  name: "EventItemDetail_5",
  components: {
    Head,
    Footer,
  },
  data() {
    return {
      EIDId: -1,
      EventItemDetailData: {},
      SideDishes: [],
    };
  },
  beforeCreate: function () {
    if (!$cookies.isKey("is_login_token")) {
      Swal.fire({
        title: "請先登入帳號",
        icon: "info",
        allowOutsideClick: false,
        heightAuto: false,
        willClose: () => {
          this.$router.push({
            name: "LoginForUser",
          });
        },
      });
      return;
    }
  },
  created: function () {
    if (this.$route.params.EIDId) {
      this.EIDId = this.$route.params.EIDId;
    }
    Vue.axios
      .get(
        this.$store.state.src + this.$store.state.subDirectory + "/Html/EventItemDetail",
        {
          params: { EId: this.$route.params.EId, EIId: this.$route.params.EIId, EIDId: this.EIDId, token: $cookies.get("is_login_token") },
        }
      )
      .then((response) => {
        this.EventItemDetailData = response.data;
        this.SideDishes = this.EventItemDetailData.SideDishes;
        if (!this.EventItemDetailData.UserInfo ||
          this.EventItemDetailData.UserInfo.UIId == -1) {
          Swal.fire({
            title: "請先填寫基本資料",
            icon: "info",
            allowOutsideClick: false,
            heightAuto: false,
            willClose: () => {
              this.$router.push({
                name: "BaseInfo",
                params: { EId: this.$route.params.EId },
              });
            },
          });
        }
      })
      .catch((error) => {
        console.log(error);
      });
  },
  mounted: function () {
  },
  updated: function () {
    if (this.EventItemDetailData.Review.ReviewStatus != 0 && this.EventItemDetailData.Review.ReviewStatus != 3) {
      $("#stet_1 input").attr("disabled", "disabled").off('click');
      $("#stet_1 textarea").attr("disabled", "disabled").off('click');
    }
    this.setInputMaxlengths();
  },
  methods: {
    checkFiles(event) {
      let that = this;
      var id = event.target.id;
      var e = event.target;
      if (e.files.length != 0) {
        // 顯示請稍候
        Swal.fire({
          title: "請稍候...",
          allowOutsideClick: false,
          showConfirmButton: false,
          heightAuto: false,
          willOpen: function () {
            Swal.showLoading();
          },
        });
        var file = e.files[0];
        // 不進行壓縮的情況要檢查大小
        if (file.size > 104857600) {
          Swal.fire({
            title: "錯誤",
            text: "檔案大小超過100MB",
            icon: "error",
            allowOutsideClick: false,
            confirmButtonText: "確定",
            heightAuto: false,
          });
        } else {
          var reader = new FileReader();
          reader.onloadend = function () {
            if (id == "T5_DishPhoto") {
              that.EventItemDetailData.EventItemDetail.T5_DishPhoto = reader.result;
            } else if (id == "T5_DishPhoto2") {
              that.EventItemDetailData.EventItemDetail.T5_DishPhoto2 = reader.result;
            }
            $("#" + id + "_data").val(reader.result);
            $("#" + id + "_name").val(file.name);
            //$("#" + id).val('');
            Swal.close();
          };
          reader.onerror = function (error) {
            $("#" + id).val("");
            Swal.fire({
              title: "錯誤",
              html:
                "處理檔案過程發生錯誤:<br />" +
                error +
                "<br />若持續發生此問題請聯繫客服人員, 造成不便敬請見諒",
              icon: "error",
              allowOutsideClick: false,
              confirmButtonText: "確定",
              heightAuto: false,
            });
          };
          reader.readAsDataURL(file);
        }
      }
    },
    addSideDishe() {
      this.SideDishes.push({
        SideDisheContent: '',
        IngredientOrigin: '',
        LocalIngredientsRatio: 0,
        DomesticProductRecord: false,
        UseExtraIngredients: false,
      });
    },
    removeSideDishe() {
      if (this.SideDishes.length > 1) {
        this.SideDishes.splice(this.SideDishes.length - 1);
      }
    },
    save(isTemp) {
      if (isTemp) {
        this.EventItemDetailData.EventItemDetail.IsTemp = true;
      } else {
        this.EventItemDetailData.EventItemDetail.IsTemp = false;
        var hasError = false;
        $("[data-required='1']").each(function () {
          var input = $(this);
          if (!input.val() || input.val() == '-1') {
            input.focus();
            Swal.fire({
              title: "錯誤",
              text: input.data("required-msg"),
              icon: "error",
              allowOutsideClick: false,
              confirmButtonText: "確定",
              heightAuto: false,
            });
            hasError = true;
            return false;
          } else if (input.attr("type") == "email" &&
            !Validate.reg_email(input.val())) {
            Swal.fire({
              title: "錯誤",
              text: "Email格式錯誤",
              icon: "error",
              allowOutsideClick: false,
              confirmButtonText: "確定",
              heightAuto: false,
            });
            hasError = true;
            return false;
          } else if (input.attr("type") == "number" &&
            input.val() < 0) {
            Swal.fire({
              title: "錯誤",
              text: "數字不可小於0",
              icon: "error",
              allowOutsideClick: false,
              confirmButtonText: "確定",
              heightAuto: false,
            });
            hasError = true;
            return false;
          }
        });
        if (hasError) {
          return;
        }
        var SideDisheError = false;
        $.each(this.SideDishes, function (index, SideDishe) {
          if (SideDishe.SideDisheContent == "" ||
            SideDishe.IngredientOrigin == "") {
            SideDisheError = true;
            return;
          }
          if (SideDisheError) {
            Swal.fire({
              title: "錯誤",
              text: "請確實輸入配菜資料",
              icon: "error",
              allowOutsideClick: false,
              confirmButtonText: "確定",
              heightAuto: false,
            });
            return;
          }
        });
      }
      Swal.fire({
        title: "請稍候...",
        allowOutsideClick: false,
        showConfirmButton: false,
        heightAuto: false,
        willOpen: function () {
          Swal.showLoading();
        },
      });
      // 儲存檔案名稱
      var AttachmentNames = "{";
      $("[data-namgtag='1']").each(function () {
        if (AttachmentNames.length > 1) { AttachmentNames += ", "; }
        var input = $(this);
        AttachmentNames += '"' + input.attr("id").replace("_name", "") + '": "' + input.val() + '"';
      });
      AttachmentNames += "}";
      let that = this;
      $.ajax({
        url:
          that.$store.state.src +
          that.$store.state.subDirectory +
          "/Html/EventItemDetail",
        type: "post",
        data: {
          EventItemDetailJson: JSON.stringify(that.EventItemDetailData.EventItemDetail),
          AttachmentNames: AttachmentNames,
          SideDishes: JSON.stringify(that.SideDishes),
          token: $cookies.get("is_login_token")
        },
        dataType: "json",
        error: function () { },
        success: function (res) {
          if (res.ok) {
            Swal.fire({
              title: isTemp ? "暫存成功" : "儲存成功",
              text: "即將返回列表",
              icon: "success",
              allowOutsideClick: false,
              showConfirmButton: false,
              heightAuto: false,
              timer: 1500,
              willClose: () => {
                that.$router.push({
                  name: "EventItem",
                  params: { EId: that.EventItemDetailData.Event.EId }
                });
              },
            });
          } else if (res.error) {
            Swal.fire({
              title: "錯誤",
              text: res.error,
              icon: "error",
              allowOutsideClick: false,
              confirmButtonText: "確定",
              heightAuto: false,
            });
          }
        }
      });
    },
    goto(pageName) {
      this.$router.push({
        name: pageName,
        params: { EId: this.$route.params.EId },
      });
    },
    sendReview() {
      let that = this;
      Swal.fire({
        heightAuto: false,
        title: "請再次確認",
        text: "送出審核後將無法再進行修改，是否確認送出?",
        icon: "info",
        allowOutsideClick: false,
        confirmButtonText: "是",
        showCancelButton: true,
        cancelButtonText: "否",
      })
        .then((result) => {
          if (result.isConfirmed) {
            Swal.fire({
              title: "請稍候...",
              allowOutsideClick: false,
              showConfirmButton: false,
              heightAuto: false,
              willOpen: function () {
                Swal.showLoading();
              },
            });
            $.ajax({
              url:
                that.$store.state.src +
                that.$store.state.subDirectory +
                "/Html/SendReview",
              type: "post",
              data: {
                EId: this.$route.params.EId,
                token: $cookies.get("is_login_token")
              },
              dataType: "json",
              error: function () { },
              success: function (res) {
                if (res.ok) {
                  Swal.fire({
                    title: "送出成功",
                    icon: "success",
                    allowOutsideClick: false,
                    showConfirmButton: false,
                    heightAuto: false,
                    timer: 1500,
                    willClose: () => {
                      location.reload();
                    },
                  });
                } else if (res.error) {
                  Swal.fire({
                    title: "錯誤",
                    text: res.error,
                    icon: "error",
                    allowOutsideClick: false,
                    confirmButtonText: "確定",
                    heightAuto: false,
                  });
                }
              }
            });
          }
        });
    },
    setInputMaxlengths() {
      console.log(1)
      const self = this;
      $('input[type="text"][data-field], textarea[data-field]').each(function () {
        console.log(2)
        const $input = $(this);
        const field = $input.data('field');
        const lengthInfo = self.EventItemDetailData.ColumnLengthInfos[field];
        if (lengthInfo) {
          $input.attr('maxlength', lengthInfo);
        }
      });
      $('input[type="number"]').each(function () {
        const $input = $(this);
        $input.attr({
          type: 'text',
          inputmode: 'numeric',
          pattern: '[0-9]*',
          oninput: "this.value = this.value.replace(/[^0-9]/g, '')",
          onpaste: "event.preventDefault()",
          'data-required': '1',
        });
        const placeholder = $input.attr('placeholder') || '';
        $input.attr('data-required-msg', placeholder);
        $input.removeAttr('min');
        // 4. 設定預設值為 0（若為空）
        if ($input.val().trim() === '') {
          $input.val('0');
        }
        // 5. 當失焦時，若為空自動補 0
        $input.on('blur', function () {
          if ($(this).val().trim() === '') {
            $(this).val('0');
          }
        });
      });
    }
  },
};
</script>
